module.exports = __webpack_public_path__ + "media/images/history/knopova1-21b8a1ea017a46803e7fcf4462fc13d2.jpg";